module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Active-call-3beaa37553e96ef30eb0d680b8b75d16.svg";